import { Tag } from "@superbright/react-component-library/Tag";

import { Typography } from "components";

import styles from "./SmallUnitCard.module.css";

export interface SmallUnitCardProps {
  availableCount: number;
  title: string;
  address: string;
  imageUrl?: string;
  href: string;
}

export const SmallUnitCard = ({
  availableCount,
  title,
  address,
  imageUrl,
  href,
}: SmallUnitCardProps) => {
  return (
    <a
      className={styles.card}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {imageUrl && (
        <div className={styles.imageWrapper}>
          <img
            src={imageUrl}
            alt={title}
            className={styles.image}
            loading="lazy"
            decoding="async"
          />
        </div>
      )}

      {availableCount ? (
        <div className={styles.tag}>
          <Tag label={`${availableCount} Available`} />
        </div>
      ) : null}
      <div className={styles.bottomInfo}>
        <div className={styles.blurGradient} />
        <Typography variant="small" weight="medium" color="card">
          {title}
        </Typography>
        <Typography variant="caption" color="card">
          <span className={styles.address}>{address}</span>
        </Typography>
      </div>
    </a>
  );
};
